<template>
    <v-layout row>
        <v-dialog v-model="dialog" persistent max-width="1000px">
            <v-btn slot="activator" color="secondary" class="text--primary">Add new trs</v-btn>
            <v-card>
                <form v-on:submit.prevent="create">
                    <v-card-title>
                        <span class="headline">Add new trs</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.trs_code"
                                            :error-messages="errors.collect('data.trs_code')"
                                            label="Code"
                                            data-vv-name="data.trs_code"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.trs_description"
                                            :error-messages="errors.collect('data.trs_description')"
                                            label="Description"
                                            data-vv-name="data.trs_description"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.trs_quantity"
                                            :error-messages="errors.collect('data.trs_quantity')"
                                            label="Quantity"
                                            data-vv-name="data.trs_quantity"
                                            @change="calcularPrecio"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required|decimal'"
                                            v-model="data.trs_unit_price"
                                            :error-messages="errors.collect('data.trs_unit_price')"
                                            label="Unit price"
                                            data-vv-name="data.trs_unit_price"
                                            @change="calcularPrecio"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required|decimal'"
                                            v-model="data.trs_vat"
                                            :error-messages="errors.collect('data.trs_vat')"
                                            label="Vat"
                                            data-vv-name="data.trs_vat"
                                            @change="calcularPrecio"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required|decimal'"
                                            v-model="data.trs_total_price"
                                            :error-messages="errors.collect('data.trs_total_price')"
                                            label="Total price"
                                            data-vv-name="data.trs_total_price"
                                            v-on:change="calcularPrecio()"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                        <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
                    </v-card-actions>
                </form>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import { DICCIONARIO } from '../../../../../diccionario';

    export default {
        props: ['id'],
        data: () => ({
            dialog: false,
            data : {
                trs_code : '',
                trs_description : '',
                trs_quantity : 0,
                trs_unit_price : 0,
                trs_total_price : '',
                trs_vat: 0
            },
            types: null,
            label: 'Kg'
        }),
        created () {
            this.getTypeUnits();
        },
        mounted () {
            this.$validator.localize('en', DICCIONARIO)
        },
        methods: {
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.data.id = this.id;
                        this.$store.dispatch('createOrderTransport', this.data).then((res) => {
                            this.$emit('created');
                            this.data =  {
                                trs_code : '',
                                trs_description : '',
                                trs_quantity : 0,
                                trs_unit_price : 0,
                                trs_total_price : '',
                                trs_vat: 0
                            };
                            this.dialog = false
                        }).catch((error) => {

                        });
                    }
                });
            },
            cancel () {
                this.dialog = false;
                this.data =  {
                                trs_code : '',
                                trs_description : '',
                                trs_quantity : 0,
                                trs_unit_price : 0,
                                trs_total_price : '',
                                trs_vat: 0
                            };
            },
            calcularPrecio () {
                this.data.trs_total_price = this.data.trs_quantity * this.data.trs_unit_price;
            },
            getTypeUnits () {
                this.$store.dispatch('selectTypeUnits').then((res) => {
                    this.types = res.data;
                }).catch((error) => {

                });
            },
            editLabel () {
                if (this.data.tipo_unidad_id == 2) {
                    this.label = 'Units';
                } else {
                    this.label = 'Kgs';
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/admin/orders/views/components/CreateOrderTransport.vue